import {UrlParamStateType} from "module/UrlParam/reducer/UrlParamReducer";

export const selUrlParams = (state: UrlParamStateType) => state.UrlParams;
export const selUrlParamsModel = (state: UrlParamStateType) => state.UrlParams.model;
